module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[87]330.beecac4.woff2";